import colors from '@theme/colors';

// lio standard light - this will swap depending on the page
export const standardLightPalette = {
  background: {
    main: colors.LIGHT_GRAY,
    paper: colors.WHITE_100,
    light: colors.WHITE_100,
    secondary: colors.SEAFOAM_SUPPLEMENTAL,

    gradient: 'linear-gradient(121.14deg, #36506D 0%, #1C2D40 100%)',
  },
  secondary: {
    light: colors.SEAFOAM,
    main: colors.SEAFOAM_SUPPLEMENTAL,
    dark: colors.DARK_SEAFOAM,
    alt: colors.SKY_BLUE,
  },
  other: {
    success: colors.LIGHT_SUCCESS,
    error: colors.LIGHT_ERROR,
    divider: colors.BLACK_10,
    highlight: colors.SUN_YELLOW_SUPPLEMENTAL,
    bindIncomplete: colors.LIGHT_BIND_INCOMPLETE,
  },
  text: {
    main: colors.BLACK_100, // text - main content color
    subdued: colors.BLACK_60, // text - titles/labels
    disabled: colors.BLACK_40, // disabled text
    caption: colors.CAPTION, // helper text mostly
    placeholder: colors.BLACK_30, // placeholder text color
    secondary: colors.DARK_GRAY, // look into replacing subdued with this
  },
  button: {
    tertiary: colors.SEAFOAM_SUPPLEMENTAL,
    tertiaryDark: colors.SUN_YELLOW_SUPPLEMENTAL,
    outlinedDark: colors.NAVY,
    outlined: colors.WHITE_100,
    containedDisabledText: colors.WHITE_60,
  },
  icon: {
    dark: colors.FADED_NAVY,
    hover: colors.FADED_NAVY_HOVER,
    disabled: colors.BLACK_10,
    main: colors.WHITE_100,
  },
};

// lio standard dark - this will swap depending on the page
export const standardDarkPalette = {
  background: {
    main: colors.NAVY,
    paper: '#00000000',
    secondary: colors.SUN_YELLOW_SUPPLEMENTAL,
    light: colors.FADED_NAVY,
    alt: colors.FADED_NAVY,

    // used all over in lio so we need it - other themes would probably not be a gradient
    gradient: 'linear-gradient(121.14deg, #36506D 0%, #1C2D40 100%)',
  },
  secondary: {
    light: colors.SUN_YELLOW,
    main: colors.SUN_YELLOW_SUPPLEMENTAL,
    dark: colors.DARK_SEAFOAM,
    alt: colors.SKY_BLUE,
  },
  text: {
    main: colors.WHITE_100,
    subdued: colors.WHITE_60,
    disabled: colors.WHITE_60,
    caption: colors.WHITE_80,
    placeholder: colors.BLACK_30,
    secondary: colors.DARK_GRAY,
  },
  button: {
    tertiary: colors.SUN_YELLOW_SUPPLEMENTAL,
    tertiaryDark: colors.SEAFOAM_SUPPLEMENTAL,
    outlinedDark: colors.WHITE_100,
    outlined: colors.NAVY,
    containedDisabledText: colors.BLACK_60,
  },
  other: {
    success: colors.DARK_SUCCESS,
    error: colors.DARK_ERROR,
    divider: colors.WHITE_30,
    highlight: colors.SEAFOAM,
    bindIncomplete: colors.DARK_BIND_INCOMPLETE,
  },
  icon: {
    dark: colors.WHITE_100,
    hover: colors.FADED_NAVY_HOVER,
    disabled: colors.WHITE_30,
    backgroundDark: colors.WHITE_15,
    main: colors.NAVY,
  },
};

export const standardLioTheme = {
  panel: {
    light: colors.WHITE_100,
    main: colors.WHITE_10,
    dark: colors.BLACK_10,
  },
  border: {
    default: colors.BORDER_LIGHT_GRAY,
    light: colors.WHITE_10,
    main: colors.BLACK_25,
    dark: colors.BLACK_60,
  },
  dataGrid: {
    borderLeft: colors.SEAFOAM,
    columnHeaderSorted: colors.SEAFOAM_SUPPLEMENTAL,
    selectedRow: '#EAF7FF',
  },

  drawerNavigation: {
    main: colors.WHITE_100,
    light: colors.LIGHT_GRAY,
    alt: colors.FADED_NAVY_HOVER,
  },
  info: {
    main: colors.LIGHT_SKY_BLUE,
    dark: colors.SKY_BLUE,
    hint: colors.BLACK_60,
  },
  success: {
    main: colors.DARK_SUCCESS,
    light: colors.LIGHT_SUCCESS,
    default: colors.DARK_SUCCESS,
  },
  error: {
    light: colors.LIGHT_ERROR,
    main: colors.DARK_ERROR,
    default: colors.DARK_ERROR,
  },
  warning: {
    main: colors.SUN_YELLOW_SUPPLEMENTAL,
    dark: colors.SUN_YELLOW,
  },
  primary: {
    main: colors.NAVY,
    dark: colors.FADED_NAVY, // this is used ALL OVER as backgrounds, this is most likely incorrect.
    light: colors.FADED_NAVY_HOVER,
  },
  accent: {
    secondary: colors.CORAL,
    tertiary: colors.SUN_YELLOW_SUPPLEMENTAL,
  },
};
